import { FC } from 'react';
import { PenToSquareIcon } from '../../theme/Icons';
import { ViewNoteSection } from './ViewNoteSection';
import { LinkText } from '../../components/LinkText';
import { SelectableText } from '../../components/SelectableText';

export const UserNotes: FC<{ content: string; editHandler?: () => void; hasAISummary?: boolean; }> = ({ content, editHandler, hasAISummary }) => {
    if (!content && !editHandler) {
        return null;
    }
    return (
        <div style={{marginTop: 8}}>
            <ViewNoteSection title="Your Notes" Icon={PenToSquareIcon}>
                {content ? (
                    <SelectableText>{content}</SelectableText>
                ): (
                    <div>
                        {editHandler &&
                            <><LinkText data-type="edit-link" onClick={editHandler}>Edit</LinkText> to add {hasAISummary ? 'your own ' : ''}notes.</>
                        }
                    </div>
                )}
            </ViewNoteSection>
        </div>
    );
};
